import React, { useState, useEffect, useRef, useCallback } from 'react';
import { useFormikContext } from 'formik';
import { useSelector, useDispatch } from 'react-redux';
import { Row, Col } from 'antd';
import { setIsRefetch } from '../../../Slices/salesSlice';
import { TextareaField } from '../../../blueplanitUtils/InputField';

const CommentField = ({ label, name }) => {
  const { values, setFieldValue, setFieldTouched, dirty, setFormikState } = useFormikContext();
  const dispatch = useDispatch();
  const isRefetch = useSelector((state) => state.sales.isRefetch);

  const [comment, setComment] = useState(() => values?.[name] || '');
  const isInitializedRef = useRef(false);
  const syncTimeoutRef = useRef(null);
  const isMountedRef = useRef(true);

  // Initialize once on mount
  useEffect(() => {
    isInitializedRef.current = true;
    isMountedRef.current = true;

    return () => {
      isMountedRef.current = false;
    };
  }, []);

  // Handle refetch
  useEffect(() => {
    if (isRefetch && values?.[name]) {
      setComment(values[name]);
      dispatch(setIsRefetch(false));
    }
  }, [isRefetch, dispatch, values, name]);

  // ✅ IMMEDIATE SYNC (no debounce delay)
  useEffect(() => {
    if (!isInitializedRef.current || comment === values?.[name]) return;

    // Clear existing timeout
    if (syncTimeoutRef.current) {
      clearTimeout(syncTimeoutRef.current);
    }

    // ✅ Sync IMMEDIATELY to Formik (no delay)
    if (isMountedRef.current) {
      setFieldValue(name, comment, false);
      setFieldTouched(name, true, false);
      
      // ✅ Force Formik to recognize as dirty
      setFormikState((prevState) => ({
        ...prevState,
        dirty: true,
      }));
    }
  }, [comment, name, setFieldValue, setFieldTouched, setFormikState, values]);

  const handleCommentChange = useCallback((e) => {
    const value = e.target.value;
    setComment(value);
  }, []);

  return (
    <Row style={{ marginTop: '16px' }}>
      <Col span={24}>
        <TextareaField
          name={name}
          label={label}
          value={comment}
          onChange={handleCommentChange}
          rows={2}
        />
      </Col>
    </Row>
  );
};

export default CommentField;